module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("6F5Qf"))).then(() => parcelRequire('5erN3'));